import React from 'react';
import DualSigmoidModel from './components/DualSigmoidModel';

function App() {
  return (
    <div className="App">
      <DualSigmoidModel />
    </div>
  );
}

export default App;
